// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"ca27526b","409":"da11b647","411":"d8ea22ac","422":"3e4308e9","560":"6cd258bc","621":"99bf2e74","633":"b85e1669","724":"151f023b","775":"ab3e269d","787":"e2c716d7","830":"1d260eea","863":"8b1befd6","867":"554c81e5","930":"f1b0b80f","939":"22b5c490","985":"4a5f4dd2"}[chunkId] + ".chunk.js";
};